import EformBaseService from '../../../../services/EformBaseService'

export default class BeschwerdeformularService extends EformBaseService {

  constructor() {
    super('wbf/seco/beschwerdeformular')
  }

}
